import {
  AudioComponent,
  CONTENT_TYPE,
  ImageComponent,
  TextContainer,
} from "@educaplay/core";
import classes from "./ResultSideNode.module.scss";

export function ResultSideNode({ data }) {
  switch (data.media.type) {
    case CONTENT_TYPE.AUDIO:
      return (
        <div className={classes.sideNode}>
          <AudioComponent
            source={data.media.value}
            className={classes.audioComponent}
          />
          {data.value && (
            <TextContainer className={classes.text} text={data.value} />
          )}
        </div>
      );
    case CONTENT_TYPE.IMAGE:
      return (
        <div className={classes.sideNode}>
          <ImageComponent
            source={data.media.value}
            className={classes.imageComponent}
          />
          {data.value && (
            <TextContainer className={classes.text} text={data.value} />
          )}
        </div>
      );
    case undefined:
      return (
        <div className={classes.sideNode}>
          <TextContainer className={classes.text} text={data.value} />
        </div>
      );
    default:
      return <div className={classes.sideNode}> - </div>;
  }
}
